import * as React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchCareerWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import { getCookie } from 'src/helpers';

class Career extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.fetchCareerWP({
			number: 100,
			orderby: 'date',
			order: 'desc',
			post_type: 'career'
		});
		document.title = this.props.t('career');
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.career.loading) {
			return false;
		} else {
			return true;
		}
	}

	render() {

		const { career } = this.props;

		var data_career = [];

		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		let filteredList = _.filter(career.data, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		filteredList.map(item => {
			var link = '';
			var terms = '';
			if (item.custom_fields.length > 0) {
				terms = item.terms[0]['name'];
			}
			if (item.terms.length > 0) {
				link = item.custom_fields[1]['value'];
			}
			data_career.push({
				post_title: item.post_title,
				post_id: item.post_id,
				post_excerpt: item.post_excerpt,
				link: link,
				terms: terms
			});
		});

		const arr_group = _(data_career)
			.groupBy('terms')
			.map((objs, key) => ({
				'key': key,
				'item': objs
			})).value();

		var list_job = arr_group.map(function (item, index) {
			return (
				<div className="list-jobs" key={index}>
					<h3 className="title-cat">
						{item.key}
					</h3>
					<div className="box-cat">
						{item.item.map(val => {
							return (
								<div className="item-job full">
									<div className="cell name-job">
										<h4 className="title"><a href={val.link} target="_blank">{val.post_title}</a>
										</h4>
									</div>
									<div className="cell desc">
										<p className="info date"><span className="icon-clock6 -ap">
											<img src={require('../img/icon-clock.png')} height="15"/></span> Full-time</p>
										<p className="info"><span className="icon-location6 -ap">
											<img src={require('../img/icon-location.png')} height="15"/></span>
											{val.post_excerpt}
										</p>
									</div>
									<div className="cta cell">
										<a href={val.link} target="_blank" className="btn-apply">Ứng tuyển </a>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			);
		});

		return (
			<div className="recruitment recruitmentWrap">
				<div className="bannerCover "
				     style={{ background: `url(${require('../img/demo3.png')}) no-repeat center center/cover` }}>
					<div className="hero-text">
						<div className="container">
							<p className="headline">Cơ hội nghề nghiệp</p>
							<h2 className="title">Trở thành thành viên trong gia đình Cộng CàPhê</h2>
							<a href="#alljobs" className="cta">Các vị trí hiện tại</a>
						</div>
					</div>
				</div>
				<div className="workat">
					<div className="container">
						<div className="info-company">
							<div className="head-sec">
								<h2 className="title-main">Nhân viên là cốt lõi của bền vững</h2>
							</div>
							<div className="sec-text">
								<p>Chúng tôi tin rằng xây dựng được hạnh phúc, chú trọng con đường sự nghiệp cho nhân
									viên, sự hài lòng trong công việc và môi trường tích cực sẽ là nền tảng lâu dài cho
									sự phát triển bền vững của Cộng CàPhê. Hãy đến với chúng tôi khi nhận thấy những giá
									trị này phù hợp với bạn!</p>
							</div>
						</div>
						<div className="benefit">
							<div className="head-sec">
								<h2 className="title-main">Thông điệp của Cộng gửi tới nhân viên</h2>
							</div>
							<div className="sec-text">
								<div className="item">
									<div className="image">
										<img src={require('../img/img-maskPost370x250.png')}
										     style={{ background: `url(${require('../img/dmtd1.jpg')}) no-repeat center center/cover` }}/>
									</div>
									<h3 className="title">Giá trị cốt lõi</h3>
									<p className="desc">It is a long established fact that a reader will be distracted
										by the readable content of a page when looking at its layout. The point of using
										Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
										opposed to using</p>
								</div>
								<div className="item">
									<div className="image">
										<img src={require('../img/img-maskPost370x250.png')}
										     style={{ background: `url(${require('../img/dmtd2.jpg')}) no-repeat center center/cover` }}/>
									</div>
									<h3 className="title">Tầm nhìn</h3>
									<p className="desc">It is a long established fact that a reader will be distracted
										by the readable content of a page when looking at its layout. The point of using
										Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
										opposed to using</p>
								</div>
								<div className="item">
									<div className="image">
										<img src={require('../img/img-maskPost370x250.png')}
										     style={{ background: `url(${require('../img/dmtd3.jpg')}) no-repeat center center/cover` }}/>
									</div>
									<h3 className="title">Sứ mệnh</h3>
									<p className="desc">It is a long established fact that a reader will be distracted
										by the readable content of a page when looking at its layout. The point of using
										Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
										opposed to using</p>
								</div>
								<div className="clearfix"/>
							</div>
							<div className="sec-image">
								<img src={require('../img/company.jpg')}/>
							</div>
						</div>
					</div>
				</div>
				<div className="hero-banner saycustomer">
					<div className="cover">
						<img src={require('../img/say.jpg')}/>
					</div>
					<div className="container">
						<div className="hero-text">
							<h3 className="title"> Sứ mệnh truyền tải hạnh phúc</h3>
							<p className="say">Tại Cộng CàPhê, chúng tôi trân trọng và đề cao giá trị kết nối giữa con
								người và trải nghiệm của khách hàng. Chúng tôi tin tưởng mạnh mẽ rằng niềm vui của khách
								hàng sẽ được mang đến từ chính sự lan tỏa hạnh phúc từ những nhân viên tận tâm tại đây.
								Lẽ đó, một trong những cốt lõi hiện tại của doanh nghiệp là xây dựng được đội ngũ hạnh
								phúc và bền vững.
							</p>
						</div>
					</div>
				</div>
				<div id="alljobs" className="jobs">
					<div className="container">
						<div className="head-sec">
							<h2 className="title-main">Các vị trí hiện tại</h2>
							<p className="desc">
								Chúng tôi luôn tìm kiếm những người tuyệt vời! Nếu bạn chưa tìm thấy cơ hội phù hợp hiện
								tại, nhưng
								tin rằng bạn có thể trở thành 1 phần của Cộng CàPhê, hãy gửi thông tin cho chúng tôi.
							</p>
						</div>
						<div className="content-sec">
							{list_job}
						</div>
						<div className="clearfix"/>
					</div>
				</div>
			</div>

		);
	}
}

export default connect(mapStateToProps([
	'career'
]), mapDispatchToProps({
	fetchCareerWP
}))(translate('translations')(Career));



// WEBPACK FOOTER //
// ./src/containers/Career.tsx